export default {"src":"/_next/static/media/add_photo.02246557.svg","height":25,"width":26};